import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import articlesData from '../data/articles.json';
import { formatDate } from '../utils/dateFormat';

function Articles() {
  return (
    <Container>
      <h1 className="mb-4 text-white">Articles</h1>
      <Row className="g-4">
        {articlesData.articles.map((article) => (
          <Col key={article.id} md={6} lg={4}>
            <Card className="bg-dark text-white">
              {article.image && (
                <Card.Img 
                  variant="top" 
                  src={article.image} 
                  alt={article.title}
                  className="article-image"
                />
              )}
              <Card.Body>
                <Card.Title className="text-white">{article.title}</Card.Title>
                <Card.Subtitle className="mb-2 text-accent">Published: {formatDate(article.date)}</Card.Subtitle>
                <div className="card-text text-white">
                  <ReactMarkdown rehypePlugins={[rehypeRaw]}>{article.summary}</ReactMarkdown>
                </div>
                <Link to={`/articles/${article.id}`} className="btn btn-primary mt-3">
                  Read More
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Articles; 